<template>
  <!-- 导入模板 -->
  <el-dialog
    :title="`导入`"
    :visible.sync="visible"
    class="file-upload"
    center>
      <div style="text-align: center;">
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :multiple="true"
          :limit="limit || undefined"
          :auto-upload="false"
          :on-exceed="onExceed"
          ref="fileUpload"
          >
          <i class="el-icon-upload"></i>
          <!-- 将文件拖到此处，或  点击上传-->
          <div class="el-upload__text">将文件拖到此处</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取 消 -->
        <el-button size="small" @click="visible = false">取消</el-button>
        <!-- 确 定 -->
        <el-button size="small" type="primary" @click="confirm()">确定</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'FileReader',
  props: {
    limit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    async confirm() {
      // 开始上传
      const files = this.$refs.fileUpload.uploadFiles
      if (!files || !files.length) {
        this.$message.error(`请选择文件`)
        return
      }
      const readPromises = []

      files.forEach(i => {
        readPromises.push(this.readFile(i))
      })

      Promise.all(readPromises)
      .then(res => {
        this.complete(res)
      })
    },
    readFile(file) {
      const {
        raw, name
      } = file
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.readAsText(raw)
        reader.addEventListener('load', () => {
          const data = {
            name,
            result: reader.result
          }

          resolve(data)
        })

        reader.addEventListener('error', () => {
          this.$message.error('文件读取出错')
          resolve(null)
        })
      })
    },
    complete(files) {
      this.$emit('complete', files)
      this.reset()
      this.visible = false
    },
    reset() {
      this.$refs.fileUpload.uploadFiles = []
    },
    onExceed() {
      this.$message.error(`超出数量限制: ${this.limit}`)
    },
    show() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .file-upload {
    /deep/ .el-dialog {
      width: 450px;
    }
    .span_required{
      color:red;
      font-size:18px;
    }
  }
</style>